import { useLocalStorageState } from 'ahooks';
import { SKIP_ENABLE_FIDO } from '@/constants/config';
import { useBizState } from './use-biz-state';

export function useFidoSkip() {
  const { userName } = useBizState();

  const [state, setState] = useLocalStorageState<Record<string, boolean | undefined>>(SKIP_ENABLE_FIDO, {
    defaultValue: {},
  });

  const setFidoSkip = (isSkip: boolean) =>
    setState((prev) => {
      if (isSkip) return { ...prev, [userName]: true };
      else {
        const s = { ...prev };
        delete s[userName];
        return s;
      }
    });

  const getState = (userName: string) => {
    return state[userName];
  };

  return { isSkipEnableFido: state[userName], setFidoSkip, getState };
}
